import siteSlice from './slice';

export const { fetchSite, fetchSiteSuccess, fetchSiteError, updateSiteNewIssues, updateSiteNewIssuesSuccess ,
selectedSite , selectedSiteError , selectedSiteSuccess 
} =
  siteSlice.actions;
export default siteSlice.reducer;

export * from './types';
